import { helpers } from './helpers'
import type { __InputDocumentColorHsla } from '../generated/graphql'

export function toColorHsla(i: __InputDocumentColorHsla, _a?: number): string {
  const a = _a ?? i.a
  if (helpers.isDef(a) && a >= 0 && a < 1) return `hsl(${i.h}, ${i.s}%, ${i.l}%, ${a})`
  return `hsl(${i.h}, ${i.s}%, ${i.l}%)`
}
